import axios, { type AxiosInstance, type AxiosResponse } from 'axios'

type Reauthenticate = () => Promise<void>

export const errorInterceptor = (reauthenticate: Reauthenticate) => {
  return async (error: unknown): Promise<AxiosResponse> => {
    if (axios.isAxiosError(error) && error.response?.status === 403) {
      // if we catch a 403 error, try to refresh the session
      console.warn('[API][ResponseInterceptor] Got 403, refreshing session.')
      // FN-3.5.5: re-authentication refreshes the HttpOnly `accessToken` cookie —
      // the retry carries it via withCredentials, no Authorization header needed.
      await reauthenticate()

      const { config: requestConfig } = error
      if (requestConfig) {
        requestConfig.withCredentials = true
        return axios.request(requestConfig)
      }
    }

    return Promise.reject(error)
  }
}

export const registerErrorInterceptor = (
  $axios: AxiosInstance,
  reauthenticate: Reauthenticate
): void => {
  $axios.interceptors.response.use(
    (response) => response,
    errorInterceptor(reauthenticate)
  )
}
